
import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Twitter, Instagram, Youtube, Phone, Mail, MapPin, Sparkles } from 'lucide-react';

const Footer: React.FC = () => {
  return (
    <footer className="bg-[#FAF8F5] border-t border-stone-100 pt-20 pb-10">
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-16 mb-16">
          {/* Branding & Contact */}
          <div className="space-y-8">
            <Link to="/" className="flex items-center space-x-2">
              <Sparkles className="text-amber-700" size={24} />
              <span className="text-2xl font-serif font-bold text-stone-900">Lumina Home</span>
            </Link>
            <p className="text-stone-500 text-sm leading-relaxed font-medium">
              Evinizi huzur dolu bir sığınağa dönüştüren el yapımı mumlar ve zarif dekoratif objelerle her anınıza ışık katıyoruz.
            </p>
            <div className="space-y-4">
              <div className="flex items-center space-x-4 text-stone-600 text-sm">
                <div className="w-8 h-8 bg-white rounded-lg flex items-center justify-center text-amber-700 shadow-sm"><Phone size={16} /></div>
                <span>+90 212 000 00 00</span>
              </div>
              <div className="flex items-center space-x-4 text-stone-600 text-sm">
                <div className="w-8 h-8 bg-white rounded-lg flex items-center justify-center text-amber-700 shadow-sm"><Mail size={16} /></div>
                <span>hello@luminahome.com</span>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-bold text-stone-900 mb-8 uppercase tracking-widest text-xs">Keşfet</h4>
            <ul className="space-y-5">
              <li><Link to="/about" className="text-stone-500 hover:text-amber-800 text-sm font-medium transition-colors">Hakkımızda</Link></li>
              <li><Link to="/workshop" className="text-stone-500 hover:text-amber-800 text-sm font-medium transition-colors">Atölyemiz</Link></li>
              <li><Link to="/contact" className="text-stone-500 hover:text-amber-800 text-sm font-medium transition-colors">İletişim</Link></li>
            </ul>
          </div>

          {/* Customer Service */}
          <div>
            <h4 className="font-bold text-stone-900 mb-8 uppercase tracking-widest text-xs">Müşteri Hizmetleri</h4>
            <ul className="space-y-5">
              <li><Link to="/shipping" className="text-stone-500 hover:text-amber-800 text-sm font-medium transition-colors">Teslimat & Kargo</Link></li>
              <li><Link to="/returns" className="text-stone-500 hover:text-amber-800 text-sm font-medium transition-colors">İptal & İade</Link></li>
              <li><Link to="/faq" className="text-stone-500 hover:text-amber-800 text-sm font-medium transition-colors">Sıkça Sorulan Sorular</Link></li>
              <li><Link to="/privacy" className="text-stone-500 hover:text-amber-800 text-sm font-medium transition-colors">Gizlilik Politikası</Link></li>
            </ul>
          </div>

          {/* Newsletter */}
          <div>
            <h4 className="font-bold text-stone-900 mb-8 uppercase tracking-widest text-xs">Bülten</h4>
            <p className="text-stone-500 text-sm mb-6 font-medium">Yeni koleksiyonlardan ve özel indirimlerden ilk siz haberdar olun.</p>
            <div className="relative">
              <input 
                type="email" 
                placeholder="E-posta adresiniz" 
                className="w-full bg-white border border-stone-200 rounded-xl py-3 px-4 text-sm focus:ring-2 focus:ring-amber-500 outline-none transition-all"
              />
              <button className="mt-4 w-full bg-stone-900 text-white py-3 rounded-xl font-bold text-xs uppercase tracking-widest hover:bg-amber-800 transition-all">Abone Ol</button>
            </div>
          </div>
        </div>

        {/* Bottom */}
        <div className="border-t border-stone-100 pt-10 flex flex-col md:flex-row items-center justify-between text-stone-400 text-xs gap-6 font-medium">
          <p>© 2024 Lumina Home Decor. Tüm hakları saklıdır.</p>
          <div className="flex items-center space-x-6">
            <a href="#" className="hover:text-amber-700 transition-colors"><Instagram size={20} /></a>
            <a href="#" className="hover:text-amber-700 transition-colors"><Facebook size={20} /></a>
            <a href="#" className="hover:text-amber-700 transition-colors"><Sparkles size={20} /></a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
